import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map'
import { Observable } from 'rxjs/Observable';
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
import { environment } from '.../../environments/environment';
import { type } from 'os';

declare var $: any;

import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import {
    GridDataResult,
    DataStateChangeEvent
} from '@progress/kendo-angular-grid';

const distinctZone = data => data
    .filter((x, idx, xs) => xs.findIndex(y => y.zoneName === x.zoneName) === idx);
const distinctWard = data => data
    .filter((x, idx, xs) => xs.findIndex(y => y.wardName === x.wardName) === idx);
@Component({
    selector: 'reprintData-cmp',
    templateUrl: 'uccReprintReport.component.html',
})

export class UccTransactionReprintComponent {
    search: any
    Employeedata: any
    prjId: any;
    userId: any;
    showLoader: any;
    collectionList: any;
    dataRangeModal: any;
    startDate: any;
    endDate: any;
    defaultStartDate: any;
    defaultEndDate: any;
    uccReprintList: any;
    dateLink: any;
    geocoder: any;
    uccRecardStatus = false;
    address: any;
    totalAmount: any
    totalTransaction: any
    zoneList: any
    wardList: any
    zoneId: any
    wardId: any
    uccUser: any
    mobile: any

    public gridDataCouponCollection: GridDataResult
    public distinctZone: any[]
    public distinctWard: any[]
    public groups: GroupDescriptor[] = [];
    public view: Observable<GridDataResult>;
    public gridView: DataResult;
    amount: boolean = false;
    public groupChange(groups: GroupDescriptor[]): void {
        this.groups = groups;
        this.loadProducts();
    }

    private loadProducts(): void {
        this.gridData = process(this.uccReprintList, { group: this.groups });
    }
    public gridData: GridDataResult
    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: this.uccReprintList
        };
        return result;
    }
    public state: State = {
        skip: 0,
        take: 20,
        // Initial filter descriptor
        // group :[{ field: 'wardName', aggregates: this.aggregates }],
        filter: {
            logic: 'and',
            filters: []
        }
    };

    constructor(private http: HttpClient, private auth: AuthService, private loaderService: LoaderService) {
        this.loaderService.status.subscribe((val: boolean) => {
            this.showLoader = val;
        });
        this.mobile = null
        this.zoneId = null;
        this.wardId = null;
        var firstDay = new Date();
        var lastDay = new Date();
        this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
        this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
        this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() } };
        this.allData = this.allData.bind(this);
    }

    importUccMobileReportAll() {
        window.open(environment.apiUrl + "uccNew/uccCollectionExl?prjId=" + this.prjId);
    }

    importUccReprintData() {
        var data = this.uccReprintList
        const ws_name = 'importUccReprintData';
        const wb: WorkBook = { SheetNames: [], Sheets: {} };
        const ws: any = utils.json_to_sheet(data);
        wb.SheetNames.push(ws_name);
        wb.Sheets[ws_name] = ws;
        const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
        saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'uccReprintData.xlsx');
    }
    s2ab(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
    }

    cleanData(array) {
        for (var i = 0; i < array.length; i++) {
            delete array[i].token
            delete array[i].deviceId
            delete array[i].tollfree
            delete array[i].vehId
            //delete array[i].pushId
            delete array[i].vehNo
            delete array[i].zoneId
            delete array[i].wardId
            delete array[i].prjAddress
            delete array[i].amountSqlCode
            delete array[i].prjId
            // delete array[i].geoAddress
            delete array[i].collectorUid
            //delete array[i].paymentDate
        }
        return array
    }

    getUccReprintReport(stDate, edDate) {
        this.loaderService.display(true);
        this.http.get(environment.apiUrl + 'ucc/getReprintUccTransaction?fromDate=' + stDate + '&toDate=' + edDate + '&prjId=' + this.prjId).subscribe(data => {
            var result: any
            result = data
            this.uccReprintList = result
            if (this.uccReprintList.length > 0) {
                this.loaderService.display(false);
                this.uccRecardStatus = false;
                this.distinctZone = distinctZone(this.uccReprintList)
                this.distinctWard = distinctWard(this.uccReprintList)
                this.gridData = process(this.uccReprintList, this.state);
            } else {
                this.uccRecardStatus = true;
                this.loaderService.display(false);
            }
        });
    }

    onDateRangeChanged(dataRange) {
        if (this.startDate != '' || this.startDate != null || this.startDate != undefined) {
            var startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
            var endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
            this.startDate = moment(startDate).format('YYYY-MM-DD');
            this.endDate = moment(endDate).format('YYYY-MM-DD');
            this.getUccReprintReport(this.startDate, this.endDate)
        }
        else {
            this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
            this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
            this.getUccReprintReport(this.startDate, this.endDate)
        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.loaderService.display(true);
        this.state = state;
        this.gridData = process(this.uccReprintList, this.state);
        this.loaderService.display(false);
    }

    
    deleteModalPopup(data) {
        Swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Convert it!'
        }).then((result) => {
            if (result.value) {
                this.deleteTransaction(data.receiptNo)
                // console.log(data.receiptNo);
            }
        })
    }

    deleteTransaction(data) {
        this.http.get(environment.apiUrl + 'ucc/deleteReprintData' + "?receiptNo=" + data).subscribe(data => {
            var result: any
            result = data
            if (result.code == 200) {
                var msg = result.msg
                Swal(
                    '',
                    msg,
                    'success'
                )
                this.getUccReprintReport(this.startDate, this.endDate)

            } else {
                var msg = result.msg
                Swal(
                    msg,
                    'error'
                )
                this.getUccReprintReport(this.startDate, this.endDate)
            }

        });
    }

    ngOnInit() {
        this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        this.prjId = this.auth.getAuthentication().projectId
        this.userId = this.auth.getAuthentication().id
        this.getUccReprintReport(this.startDate, this.endDate)
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/uccReport/uccReprintReport.component.ts